module.exports = __webpack_public_path__ + "img/plaza-real.f40f451f.jpg";